import React from "react";

import Hero from "components/Hero";

export default function VacancyList() {
	window.scrollTo(0, 0);
	document.title = "Vacancies || Jozini Municipality";

	return (
			<Hero
				subheading="Vacancies"
				title="Are we hiring?"
				description="Minima dolorum vero quas ullam exercitationem animi. Soluta dicta excepturi temporibus assumenda."
				backgroundImage={require("images/page-title.jpg")}
				hideAppointmentButton
			/>
	);
}
